<template>
  <el-container>
    <el-header class="header">
      <div class="nav-container">
        <div class="nav-container-left">
          <div class="logo">千里眼监控V1.0</div>
          <el-menu
            :default-active="activeIndex"
            mode="horizontal"
            background-color="#409eff"
            text-color="#fff"
            active-text-color="#fff"
          >
            <el-menu-item index="0" @click="goto('/home')">首页</el-menu-item>
            <el-submenu index="1">
              <template slot="title">平台监控</template>
              <el-menu-item index="1-1" @click="goto('/nginxAnlysis')">
                经营帮流量监控
              </el-menu-item>
              <!-- <el-menu-item index="1-2" @click="goto('/event')">
                后台事件监控
              </el-menu-item> -->

              <!-- <el-menu-item index="1-3" @click="goto('/idCardValidate')">
                第三方服务事件监控
              </el-menu-item> -->

              <el-menu-item index="1-4" @click="goto('/sysProjectList')">
                项目动态监控
              </el-menu-item>

              <!-- <el-menu-item index="1-5" @click="goto('/logView')">
                Java服务日志查看
              </el-menu-item> -->

              <el-menu-item index="1-5" @click="goto('/frontMonitor')">
               前端项目错误监控
              </el-menu-item>
              <!-- <el-menu-item index="1-4" @click="goto('/idCardValidate')">
                应用服务器在线监控
              </el-menu-item> -->

              <el-menu-item index="1-6" @click="goto('/smsLogList')">
                平台短信日志监控
              </el-menu-item>
              <el-menu-item index="1-6" @click="goto('/sysUserLoginLogList')">
                登录短信日志监控
              </el-menu-item>
            </el-submenu>

            <el-submenu index="6">
              <template slot="title">资产管理</template>
              <el-menu-item index="6-1" @click="goto('/assetList')">
                资产管理（服务器）
              </el-menu-item>
              <!-- <el-menu-item index="6-2" @click="goto('/serviceList')">
                Nacos服务管理
              </el-menu-item> -->
              <el-menu-item index="6-3" @click="goto('/sysTestReportList')">
                测试报告管理
              </el-menu-item>
              <el-menu-item index="6-4" @click="goto('/sysDepositoryList')">
                CDN镜像&监控接口资源管理
              </el-menu-item>
              
            </el-submenu>

            <el-submenu index="7">
              <template slot="title">规则引擎</template>
              <el-menu-item index="7-1" @click="goto('/sysRuleList')">
                规则管理
              </el-menu-item>
            </el-submenu>

            <el-submenu index="8">
              <template slot="title">快捷工具</template>
              <!-- <el-menu-item index="8-1" @click="goto('/mockData')">
                测试数据模拟
              </el-menu-item> -->
              <el-menu-item index="8-2" @click="goto('/gitBranch')">
                Git分支命名工具
              </el-menu-item>
              <el-menu-item index="8-3" @click="goto('/decode')">
                JSON解密工具
              </el-menu-item>

              <el-menu-item index="8-4" @click="goto('/email')">
                邮件工具
              </el-menu-item>

              <el-menu-item index="8-5" @click="goto('/connectorCategoryList')">
                连接器分类列表
              </el-menu-item>
            </el-submenu>
            <!-- <el-submenu index="5">
              <template slot="title">数据字典管理</template>
              <el-menu-item index="5-1" @click="goto('/nginxAnlysis')">
                归属地缓存管理
              </el-menu-item>
              <el-menu-item index="5-2" @click="goto('/nginxAnlysis')">
                手机验证码缓存管理
              </el-menu-item>
              <el-menu-item index="5-2" @click="goto('/nginxAnlysis')">
                行政区划缓存管理
              </el-menu-item>
              <el-menu-item index="5-2" @click="goto('/nginxAnlysis')">
                其他缓存管理
              </el-menu-item>
            </el-submenu> -->

            <!-- <el-submenu index="2">
              <template slot="title">风险监控</template>
              <el-menu-item index="2-1" @click="goto('/nginxAnlysis')">
                舆情监控
              </el-menu-item>
            </el-submenu> -->

            <el-submenu index="3">
              <template slot="title">系统管理</template>
              <el-menu-item index="3-1" @click="goto('/sysUserList')">
                用户管理
              </el-menu-item>
              <el-menu-item index="3-2" @click="goto('/roleList')">
                角色管理
              </el-menu-item>

              <!-- <el-menu-item index="3-2" @click="goto('/codeList')">
                数据字典
              </el-menu-item> -->

              <el-menu-item index="3-3" @click="goto('/menuList')">
                菜单管理
              </el-menu-item>
              <el-menu-item index="3-4" @click="goto('/sysRobotList')">
                机器人管理
              </el-menu-item>
            </el-submenu>

            <el-submenu index="4">
              <template slot="title">更新日志</template>
              <el-menu-item index="4-1" @click="goto('/changeLog')">
                更新日志
              </el-menu-item>
            </el-submenu>
          </el-menu>

          <!-- <el-menu
            :default-active="activeIndex"
            mode="horizontal"
            background-color="#409eff"
            text-color="#fff"
            active-text-color="#fff">
            <el-submenu :index="item.fid" v-for="(item,index) in permissionOfMine" :key="index">
              <template slot="title">{{item.label}}</template>
              <el-menu-item :index="each.fid" @click="goto(each.url)" v-for="(each,idx) in item.children" :key="idx">{{each.name}}</el-menu-item>
            </el-submenu>
          </el-menu> -->
        </div>
        <div class="nav-container-right">
          <el-menu
            mode="horizontal"
            background-color="#409eff"
            text-color="#fff"
            active-text-color="#fff"
          >
            <el-submenu index="11">
              <template slot="title"
                ><el-avatar
                  style="margin-right: 10px"
                  :size="30"
                  :src="circleUrl"
                ></el-avatar
                >{{ userInfo.userName }}</template
              >
              <el-menu-item index="11-1" @click="goto('/modifyUserPass')">
                <i class="el-icon-edit" style="color: white"></i>修改密码
              </el-menu-item>
              <!-- <el-menu-item index="11-2" @click="goto('/modifyUserPass')"
                ><i class="el-icon-user" style="color:white"></i>个人资料</el-menu-item
              > -->
              <el-menu-item index="11-3" @click="exit"
                ><i class="el-icon-s-promotion" style="color: white"></i
                >退出系统</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </el-header>
    <el-container class="main-container">
      <el-main class="container">
        <el-skeleton :rows="10" v-show="isLoading" animated />
        <!-- <el-breadcrumb
          separator-class="el-icon-arrow-right"
          style="margin-bottom: 10px"
        >
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>活动管理</el-breadcrumb-item>
          <el-breadcrumb-item>活动列表</el-breadcrumb-item>
          <el-breadcrumb-item>活动详情</el-breadcrumb-item>
        </el-breadcrumb> -->
        <router-view v-show="!isLoading"></router-view>
        <el-backtop target=".container"></el-backtop>
      </el-main>
    </el-container>
    <el-container>
      <el-footer class="footer">中钧科技研究院出品 2020-2021</el-footer>
    </el-container>
  </el-container>
</template>

<script>
import {
  deleteLocalStorageItem,
  getLocalStorageItem,
} from "@/utils/localstorage/LocalstorageKit";
import { navTo } from "@/utils/NavigatorUtils";
import RoleApi from "@/api/RoleApi";
export default {
  name: "MainLayout",
  data() {
    return {
      server: {
        wsUrl: process.env.VUE_APP_WS,
        imAccount: "201910091558292",
        imToken: "bfe073d0a5fb96efa91e1a40c87217ce",
        plateform: "client",
      },
      userInfo: {},
      activeIndex: "0",
      permissionOfMine: [],
      isLoading: true,
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
    };
  },
  created() {
    //获取当前路由假如不是欢迎界面,则跳转到欢迎紧密
    // if (this.$route.path !== "/") {
    //   // this.$router.replace("/");
    // }
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
    //获取当前用户的菜单权限信息
    RoleApi.queryMenuOfMine().then((resp) => {
      if (resp.state == "OK") {
        this.permissionOfMine = resp.data;
      }
    });

    // let arr = null;
    // console.log(arr.length);
    this.userInfo = JSON.parse(getLocalStorageItem("userInfo"));

    let defaultConfig = {
      wsUrl: this.server.wsUrl,
      imAccount: this.server.imAccount,
      token: this.server.imToken,
      plateform: this.server.plateform,
      onClose: () => {
        console.log("连接已关闭...");
      },
      onOpen: () => {
        console.log("连接已打开...");
      },
      onMessage: (evt) => {
        var received_msg = evt.data;
        var data = JSON.parse(received_msg);
        this.$store.commit("eventHandler", data);
        // this.$notify({
        //     title: '警告',
        //     message: "有一条新的报警来了，请及时查看",
        //     type: 'warning'
        //   });
        // var data = JSON.parse(received_msg);
        // console.log("data-->",data);
        // this.result = data;
        // this.endTime = Date.parse(new Date());
        // WsKit.onMessage(evt);
      },
    };
    this.$wsKit.init(defaultConfig);
  },
  methods: {
    goto(path) {
      navTo(this, path);
    },
    exit() {
      this.$confirmDialog("确定要进行当前操作?", (resp) => {
        deleteLocalStorageItem("token");
        deleteLocalStorageItem("userInfo");
        window.location.href = "/login";
      });
    },
  },
};
</script>

<style scoped>
.header {
  background-color: #409eff;
  display: inline-flex;
  color: #fff;
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
  font-weight: bolder;
}
.footer {
  text-align: center;
  color: #c0c4cc;
  font-size: 14px;
}
.main-container {
  height: 820px;
}

.nav-container {
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
}

.nav-container-left {
  display: inline-flex;
}

.nav-container-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>